/**
 * Функция для сжатия изображения
 * @param file
 * @param targetSizeMB
 * @returns
 */
export const compressImage = async (
  file: File,
  targetSizeMB: number
): Promise<File> => {
  // Загрузка изображения в объект Image
  const image = await loadImage(file);

  // Создание canvas для рисования изображения
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  if (!ctx) {
    throw new Error("Canvas not supported");
  }

  // Установка размеров canvas
  canvas.width = image.width;
  canvas.height = image.height;
  ctx.drawImage(image, 0, 0);

  // Максимальный размер файла в байтах
  const targetSizeBytes = targetSizeMB * 1024 * 1024;

  // Если размер изобра
  if(file.size <= targetSizeBytes) return file;

  // Начальное качество изображения для сжатия
  let quality = 0.9;
  let compressedBlob: Blob | null = null;

  // Пробуем сжать изображение до целевого размера
  while (true) {
    // Конвертация canvas в Blob с определенным качеством
    compressedBlob = await new Promise<Blob | null>((resolve) => {
      canvas.toBlob(resolve, file.type, quality);
    });

    // Проверяем, достигнут ли нужный размер
    if (compressedBlob && compressedBlob.size <= targetSizeBytes) {
      break;
    }

    // Уменьшаем качество для дальнейшего сжатия
    quality -= 0.05;

    // Если качество меньше 0, выходим из цикла
    if (quality <= 0) {
      throw new Error("Unable to compress image to the target size");
    }
  }

  // Преобразуем Blob обратно в объект File с исходным именем и расширением
  const compressedFile = new File([compressedBlob], file.name, {
    type: file.type,
  });

  return compressedFile;
};

// Вспомогательная функция для загрузки изображения
function loadImage(file: File): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);

    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };

    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("Failed to load image"));
    };

    img.src = url;
  });
}
